import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Auth from "@/pages/Auth";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Coach from "@/pages/Coach";
import Tools from "@/pages/Tools";
import Library from "@/pages/Library";
import Article from "@/pages/Article";
import Saved from "@/pages/Saved";
import FirstDatePlaybook from "@/pages/FirstDatePlaybook";
import DatePlanner from "@/pages/DatePlanner";
import ExRecovery from "@/pages/ExRecovery";
import Upgrade from "@/pages/Upgrade";
import SubscriptionReturn from "@/pages/SubscriptionReturn";
import AdminCodes from "@/pages/AdminCodes";
import AppShell from "@/components/AppShell";
import ProtectedRoute from "@/components/ProtectedRoute";

const Shell = ({ children, premium = false, feature }) => (
  <ProtectedRoute requirePremium={premium} feature={feature}>
    <AppShell>{children}</AppShell>
  </ProtectedRoute>
);

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Auth />} />

      {/* Free (library + account + subscription management) */}
      <Route path="/dashboard" element={<Shell><Dashboard /></Shell>} />
      <Route path="/library" element={<Shell><Library /></Shell>} />
      <Route path="/article/:id" element={<Shell><Article /></Shell>} />
      <Route path="/saved" element={<Shell><Saved /></Shell>} />
      <Route path="/upgrade" element={<Shell><Upgrade /></Shell>} />
      <Route path="/subscription/return" element={<SubscriptionReturn />} />
      <Route path="/admin/codes" element={<Shell><AdminCodes /></Shell>} />

      {/* Premium */}
      <Route path="/coach" element={<Shell premium feature="AI Coach"><Coach /></Shell>} />
      <Route path="/tools" element={<Shell premium feature="Interactive Tools"><Tools /></Shell>} />
      <Route path="/date-plan" element={<Shell premium feature="Date Night Planner"><DatePlanner /></Shell>} />
      <Route path="/playbook/first-date" element={<Shell premium feature="First-Date Playbook"><FirstDatePlaybook /></Shell>} />
      <Route path="/recovery" element={<Shell premium feature="Breakup Recovery"><ExRecovery /></Shell>} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" theme="dark" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
